export const REFERRAL_LANDING_PATH = "/indicacao";

const decodeSafe = (value = "") => {
  try {
    return decodeURIComponent(String(value || ""));
  } catch (_) {
    return String(value || "");
  }
};

export function normalizeReferralSource(value) {
  const decoded = decodeSafe(value);
  const trimmed = decoded.replace(/\s+/g, " ").trim();
  return trimmed || "";
}

export function extractReferralSourceFromPath(pathname = "") {
  const match = String(pathname || "").match(/^\/indicacao\/([^/?#]+)\/?$/i);
  if (!match) return "";
  return normalizeReferralSource(match[1]);
}

export function buildReferralAliasPath(source) {
  const normalized = normalizeReferralSource(source);
  if (!normalized) return `${REFERRAL_LANDING_PATH}/`;
  return `${REFERRAL_LANDING_PATH}/${encodeURIComponent(normalized)}`;
}
